import ModalLogout from './ModalLogout';

export default ModalLogout;

export interface ModalLogoutProps {
  isOpen: boolean;
  onClose: () => void;
}
